import gql from 'graphql-tag';

export default gql`
  query landingPageStadiumImages {
    application(name: DESKTOPBOOKINGPATH) {
      ... on DesktopBookingPath {
        images(section: "stadiumPackageHomePage") {
          id
          path
          alt
          title
        }
      }
    }
  }
`;
